import { environment } from "../../../environments/environment";

/**
 * True when the app is opened on the public status domain (status.dashypay.com /
 * statusdev.dashypay.com). On that domain the app serves only the status page at "/":
 * no Keycloak, no bearer token, no back-office shell.
 *
 * Local work: open http://localhost:4200/?statusPage=1 once (remembered for the tab).
 */
export function isStatusHost(): boolean {
  const host = window.location.hostname.toLowerCase();
  const hosts: string[] = environment.statusHosts ?? [];
  if (hosts.includes(host)) {
    return true;
  }
  if (host === "localhost" || host === "127.0.0.1") {
    try {
      if (new URLSearchParams(window.location.search).has("statusPage")) {
        sessionStorage.setItem("statusPage", "1");
      }
      return sessionStorage.getItem("statusPage") === "1";
    } catch {
      return false;
    }
  }
  return false;
}
